import { mediaQuery } from './media-queries';

const equalise = (equaliseParent, equaliseAt) => {
  const equaliseParents = document.querySelectorAll(
    equaliseParent ?? '[data-equalise-parent]'
  );

  equaliseParents.forEach(parent => {
    const equaliseChildren = parent.querySelectorAll('[data-equalise]');
    const heights = [];
    const mq = window.matchMedia(
      mediaQuery(equaliseAt ?? parent.dataset.equaliseAt)
    );

    if (mq.matches) {
      equaliseChildren.forEach(child => {
        heights.push(child.offsetHeight);
      });

      if (heights.length) {
        const maxHeight = Math.max(...heights);

        equaliseChildren.forEach(child => {
          child.style.height = `${maxHeight / 16}rem`;
        });
      }
    }
  });
};

export default equalise;
